'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Parse leading configuration directives from a LightScript program.
//
// XXX: Uses somewhat-hackish regular expression parsing. May be possible to
function eatFluff(code) {
  code = code.trim();
  var matches = code.match(/^(?:\/\/[^\r\n]*\r?\n?\s*)+([^]*)$/);
  if (matches) return matches[1];else {
    var lcMatches = code.match(/^(?:\/\*[^]*?\*\/\s*)+([^]*)$/);
    if (lcMatches) return lcMatches[1];else return code;
  }
}function eatDirective(code, directives) {
  code = code.trim();
  var matches = code.match(/^'((?:[^'\\]|\\.)*)'\s*;?\s*([^]*)$/);
  if (matches) {
    directives.push(matches[1]);
    return matches[2];
  } else {
    var dqMatches = code.match(/^"((?:[^"\\]|\\.)*)"\s*;?\s*([^]*)$/);
    if (dqMatches) {
      directives.push(dqMatches[1]);
      return dqMatches[2];
    } else {
      return code;
    }
  }
}function getDirectives(code) {
  var directives = [];
  var before = code,
      after = void 0;
  // eslint-disable-next-line no-constant-condition
  while (true) {
    after = eatDirective(eatFluff(before), directives);
    if (after === before) break;
    before = after;
  }return directives;
}function getClauseOptions(opts, clause) {
  clause = clause.split(':');
  if (clause.length === 2) {
    var opt = clause[0].trim();
    var val = clause[1].trim();
    if (opt.length && val.length) {
      try {
        return opts[opt] = JSON.parse(val);
      } catch (err) {
        return;
      }
    }
  } else if (clause.length === 1) {
    var _opt = clause[0].trim();
    if (_opt.length) return opts[_opt] = true;
  }
}function getWithOptions(opts, wc) {
  var clauses = wc.split(',');
  for (var _i3 = 0, _len3 = clauses.length; _i3 < _len3; _i3++) {
    var _clause = clauses[_i3];
    getClauseOptions(opts, _clause);
  }
}
exports.default = function parseConfigurationDirectives(code) {
  var result = {};
  var directives = getDirectives(code);
  for (var _i4 = 0, _len4 = directives.length; _i4 < _len4; _i4++) {
    var _directive = directives[_i4];
    var matches = _directive.match(/^use \@oigroup\/lightscript\s*(?:with ([^]*))?$/);
    if (matches) {
      result.isLightScript = true;
      if (matches[1]) getWithOptions(result, matches[1]);
    }
  }return result;
};

module.exports = exports['default'];